import { domReady } from '@roots/sage/client';
import axios from 'axios';
import AsyncAlpine from 'async-alpine';
import Alpine from 'alpinejs';
import { Menu } from './global/Menu';

__webpack_public_path__ = "/app/themes/przekroj-fundacja/public/";

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.Alpine = Alpine;

const main = async (err) => {
  if (err) {
    // handle hmr errors
    console.error(err);
  }

  const isAdmin = document.body.classList.contains('wp-admin') || document.body.classList.contains('block-editor-iframe__body');

  if (!isAdmin) {
    new Menu();
  }

  AsyncAlpine.init(Alpine);

  AsyncAlpine.data('snap', () => import(/* webpackChunkName: "Snap" */ './alpineModules/Snap'));
  AsyncAlpine.data('swiper', () => import(/* webpackChunkName: "Swiper" */ './alpineModules/Swiper'));
  AsyncAlpine.data('video', () => import(/* webpackChunkName: "Video" */ './alpineModules/Video'));
  AsyncAlpine.data('embededVideo', () => import(/* webpackChunkName: "EmbededVideo" */ './alpineModules/EmbededVideo'));

  AsyncAlpine.start();
  Alpine.start();
};

/**
 * Initialize
 *
 * @see https://webpack.js.org/api/hot-module-replacement
 */
domReady(main);
import.meta.webpackHot?.accept(main); // eslint-disable-line
